import type {AddressObjectType} from "../../../types";
import type {Address, FormData, TransportationModeType} from "../types";
import type {AutoCompleteDropdownOption} from "../../forms/auto-complete/AutoComplete";
import {countryCodeMapping} from "../constants/country-code-mapping";
import {
  API_ENUMS,
  API_ENUMS_TRANSPORTATION_MODES_TYPE,
} from "../constants/api-enums";
import {
  TRANSPORTATION_MODES,
  WEIGHT_UNITS,
} from "../constants/dropdown-options";

import type {ShipmentEntryInputData} from "../ShipmentEntryInputGroup";

/* eslint-disable camelcase */
export const parseAddress = (address: string | AddressObjectType): Address => {
  const {address_one, address_two, city, country, state, zip} = JSON.parse(
    JSON.stringify(address)
  );
  const country_code = countryCodeMapping(country);
  const addressobj = {
    street_address: address_one,
    street_address2: address_two,
    city,
    state,
    zip,
    country_code: country_code ?? "",
  };
  return addressobj;
};

interface PortReturn {
  portCode: string;
  name?: string;
}
export const parsePort = (port: AutoCompleteDropdownOption): PortReturn => {
  const {locode, iata_code, name, seaport} = port;
  if (seaport) {
    return {portCode: locode, name};
  }
  return {portCode: iata_code, name};
};

export const parseTransportationMode = (
  mode: TransportationModeType
): API_ENUMS_TRANSPORTATION_MODES_TYPE => {
  if (
    mode === TRANSPORTATION_MODES.oceanFcl ||
    mode === TRANSPORTATION_MODES.oceanLcl
  ) {
    return API_ENUMS.transportationMode.ocean;
  }
  return API_ENUMS.transportationMode[mode];
};

export const buildRequestObject = (body: ShipmentEntryInputData) => {
  const data: FormData = {
    transportation_mode: parseTransportationMode(body.transportationMode),
    is_reefer: body.isReefer === true,
    is_inland: body.isInland === true,
  };

  if (
    body.transportationMode === API_ENUMS.transportationMode.truck ||
    body.transportationMode === API_ENUMS.transportationMode.rail
  ) {
    data.origin_address = body.originAddress;
    data.destination_address = body.destinationAddress;
  } else {
    data.origin_port = body.originPortCode;
    data.destination_port = body.destinationPortCode;
    data.is_lcl = body.transportationMode === TRANSPORTATION_MODES.oceanLcl;
  }
  if (body.weight.unit === WEIGHT_UNITS.teus) {
    data.teus = `${body.weight.value}`;
  } else {
    data.weight = {
      value: body.weight.value,
      unit: body.weight.unit,
    };
  }
  return data;
};

/* eslint-enable camelcase */
